module.exports = __webpack_public_path__ + "img/ag_gallery_4.c45f2ffc.jpg";